var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5078 12.6003C23.5078 11.617 23.4295 10.8995 23.2598 10.1554H12.2295V14.5934H18.7041C18.5736 15.6963 17.8687 17.3573 16.3022 18.4733L16.2802 18.6219L19.7678 21.3721L20.0095 21.3967C22.2285 19.3105 23.5078 16.2411 23.5078 12.6003Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2294 24.2934C15.4014 24.2934 18.0643 23.2303 20.0094 21.3967L16.3021 18.4734C15.3101 19.1776 13.9786 19.6692 12.2294 19.6692C9.12268 19.6692 6.48586 17.5832 5.5459 14.6998L5.40813 14.7117L1.78168 17.5685L1.73425 17.7027C3.66618 21.6092 7.6345 24.2934 12.2294 24.2934Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54609 14.6997C5.29808 13.9557 5.15454 13.1583 5.15454 12.3346C5.15454 11.5107 5.29808 10.7135 5.53304 9.96936L5.52647 9.81089L1.85458 6.90817L1.73444 6.96634C0.938206 8.58744 0.481323 10.4079 0.481323 12.3346C0.481323 14.2612 0.938206 16.0816 1.73444 17.7027L5.54609 14.6997Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2294 4.99984C14.4355 4.99984 15.9235 5.96982 16.7721 6.78042L20.0877 3.48509C18.0514 1.5584 15.4014 0.375809 12.2294 0.375809C7.63449 0.375809 3.66617 3.05987 1.73425 6.96637L5.53285 9.9694C6.48585 7.08601 9.12267 4.99984 12.2294 4.99984Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.04,
    height: 24,
    fill: "white",
    transform: "translate(0.47998 0.375793)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ec0cb404f962974c0b8a4ba15233b4c1.svg";
export { ForwardRef as ReactComponent };